module.exports = __webpack_public_path__ + "img/fireFighting.7d7c718d.svg";